<!--
상품을 재고보관처리 한다.
------------------------------------
-->
<template>
    <div style="display: none">
        <!-- 폼 화면 -->
        <div class="uk-flex-top form" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-header">
                    <h4 class="uk-text-center">재고보관처리</h4>
                </div>

                <div class="uk-modal-body uk-padding-remove uk-flex uk-flex-between uk-child-width-1-2 uk-flex-stretch">

                    <!-- 상품정보 표시 -->
                    <div class="uk-flex uk-padding-small" style="border-right: 1px solid #eee">
                        <div class="uk-width-auto uk-text-center">
                            <div class="uk-margin-right">
                                <img
                                    :src="prod.img_url"
                                    width="100"
                                />

                                <!-- 라벨표시 -->
                                <div class="uk-margin-top">
                                    <span v-show="prod.lock_error" class="uk-label uk-label-danger">오류</span>
                                    <span v-show="prod.lock_hold" class="uk-label uk-label-danger">보류중</span>
                                </div>
                            </div>

                        </div>
                        <div class="uk-width-expand">

                            <app-column
                                class="uk-margin-small-bottom"
                                header="배송단계"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.state_text }}
                            </app-column>


                            <app-column
                                class="uk-margin-small-bottom"
                                header="상품번호"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.id }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom"
                                header="상품명"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.name }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom"
                                header="색상"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.color }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom"
                                header="사이즈"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.size }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom"
                                header="유통기한"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.expiration_date }}
                            </app-column>



                            <app-column
                                class="uk-margin-small-bottom"
                                header="보관장소"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.storage }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom"
                                header="수량"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.amount }}
                            </app-column>

                        </div>
                    </div>


                    <!-- 안내 -->
                    <div class="guide uk-flex uk-flex-column uk-flex-center">
                        <div>
                            <i class="material-icons">info</i>
                            <span class="uk-text-primary">새로운 재고상품</span>
                            이 생성되며,<br />
                            이 상품은
                            <span class="uk-text-danger">배송취소</span>
                            처리됩니다.<br />

                            정말 재고보관 처리합니까?
                        </div>
                    </div>

                </div>




                <div class="uk-modal-footer uk-text-right">
                    <!--- 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-default uk-modal-close"
                    >
                        <span uk-icon="icon: close"></span> 취소
                    </button>
                    <button
                        type="button"
                        class="uk-button uk-button-primary"
                        v-on:click="submit()"
                    >
                        <span uk-icon="icon: check"></span>
                        재고보관(완료)
                    </button>
                </div>
            </div>
        </div>


        <!-- 결과 화면 -->
        <div class="uk-flex-top result" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-header">
                    <h4 class="uk-text-center">재고보관 처리가 완료되었습니다</h4>
                </div>
                <div class="uk-modal-body uk-padding-remove">

                    <div class="uk-flex uk-child-width-1-2">
                        <!-- 기존상품 표시 -->
                        <div class="uk-padding-small" style="border-right: 1px solid #eee">
                            <div class="uk-flex uk-margin-top">
                                <div class="uk-width-auto uk-text-center">
                                    <div class="uk-margin-right">
                                        <img
                                            :src="old.img_url"
                                            width="100"
                                        />

                                        <div class="uk-margin-top">
                                            <span class="uk-label uk-label-border-dark">기존 상품</span>
                                        </div>
                                    </div>

                                </div>
                                <div class="uk-width-expand">

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="배송단계"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ old.state_text }}
                                    </app-column>


                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="상품번호"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ old.id }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="상품명"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        <div class="uk-text-truncate">
                                            {{ old.name }}
                                        </div>
                                    </app-column>


                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="유통기한"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ old.expiration_date }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="보관장소"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ old.storage }}
                                    </app-column>


                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="수량"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ old.amount }}
                                    </app-column>

                                </div>
                            </div>
                        </div>


                        <!-- 재고상품 표시 -->
                        <div class="uk-padding-small">
                            <div class="uk-flex uk-margin-top">
                                <div class="uk-width-auto uk-text-center">
                                    <div class="uk-margin-right">
                                        <img
                                            :src="stock.img_url"
                                            width="100"
                                        />

                                        <div class="uk-margin-top">
                                            <span class="uk-label uk-label-primary">새 재고상품</span>
                                        </div>
                                    </div>


                                </div>
                                <div class="uk-width-expand">

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="배송단계"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ stock.state_text }}
                                    </app-column>


                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="상품번호"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ stock.id }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="상품명"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        <div class="uk-text-truncate">
                                            {{ stock.name }}
                                        </div>
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="유통기한"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ stock.expiration_date }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="보관장소"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ stock.storage }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="수량"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ stock.amount }}
                                    </app-column>

                                </div>
                            </div>

                            <!-- 오배송(상품.색상.사이즈)인 경우 안내문구 -->
                            <div class="uk-margin-top" v-show="displayDescForDiffError">
                                <span class="uk-text-danger">[주의!!]</span>
                                <b>[상품명/색상/사이즈]가 다르게 도착한 경우</b>,<br />
                                고넬로 시스템에 등록된 [재고]상품의 정보를 렉에 보관중인 상품의
                                [상품명/색상/사이즈]와 <b>동일하게 수정</b>해 놓으셔야 재고매칭 하실 때 착오가 없습니다.
                                <br />
                                재고상품=>[상품] 페이지에서 직접
                                <a class="" :href="'/prods/'+stock.id + '/edit'">
                                    수정
                                </a>
                                하세요.
                            </div>

                            <!-- 재고상품 이동버튼 -->
                            <div class="uk-margin-top uk-text-center">
                                <a class="uk-button uk-button-small uk-button-primary" :href="'/prods/'+stock.id">
                                    <i class="material-icons">forward</i>
                                    재고상품으로 이동
                                </a>
                            </div>



                        </div>

                    </div>


                </div>


                <div class="uk-modal-footer uk-text-center">

                    <!--- 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-default"
                        @click="refreshPage"
                    >
                        <span uk-icon="icon: close"></span> 닫기
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},

                // (object) 오류정보
                error: null,

                // 폼화면 html 엘리먼트
                el_form: null,

                // 결과화면 html 엘리먼트
                el_result: null,

                // (object) 기존 상품
                old: {},

                // (object) 새 재고상품
                stock: {},
            };
        },
        computed: {
            /**
             * 오배송오류 (상품/색상/사이즈) 인경우,
             * 안내문구 display 여부
             * @return boolean
             */
            displayDescForDiffError() {
                if (! this.error) {
                    return false;
                }

                this.error.type = parseInt(this.error.type)
                return this.error.type === 11
                    || this.error.type === 12
                    || this.error.type === 13;
            },

        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                if (! this.el_form) {
                    this.el_form = $(this.$el).find('.form').get(0);
                }
                if (! this.el_result) {
                    this.el_result = $(this.$el).find('.result').get(0);
                }

                UIkit.modal(this.el_form).show();
            },

            /**
             * 폼
             * @param prod_id 상품ID
             */
            form(prod_id) {

                // 상품정보조회 Promise
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response.prod);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((prod) => {
                    this.prod = prod;

                    // 오류조회
                    return this.loadError();

                }).then((error) => {
                    this.error = error;

                    // 폼띄우기
                    this.displayForm();

                }).catch((msg) => {
                    alert(msg);
                });

            },

            /**
             * 오류정보 조회 Promise
             * @return Promise
             */
            loadError() {
                // 오류정보조회 Promise
                return new Promise((resolve, reject) => {
                    // 오류상품이 아닌경우
                    if (! this.prod.lock_error) {
                        resolve(null);
                        return;
                    }

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/errors/' + this.prod.lock_error,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response.error);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);



                });
            },

            /**
             * submit
             */
            submit() {

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/' + this.prod.id + '/to-stock-by-agent-member',
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    this.old = response.old;
                    this.stock = response.stock;

                    //UIkit.modal(this.el_form).hide();
                    UIkit.modal(this.el_result).show();
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .guide {
        padding: 1rem;
        text-align: center;
        background-color: #ffffdd;
        font-size: 1.25rem;
        line-height: 2;

        .material-icons {
            font-size: 1.5rem;
        }
    }
</style>